module.exports = __webpack_public_path__ + "static/media/nick-erlanger-large.65e59b9c.png";